import { CurrencyDto } from "./currency.dto";

export class ServiceFeeDto {
  id: number;
  percent: number;
  minAmount?: number;
  maxAmount?: number;
  currency?: CurrencyDto;
  isActive: boolean;
}